/**
 * GAD7Card - GAD-7 anxiety screen card (PROD-646 Sprint 3.3).
 *
 * Thin wrapper around `PromCard` bound to the GAD-7 definition. LOINC
 * 69737-5 (Generalized anxiety disorder 7 item panel total score).
 * Severity bands per Spitzer, Kroenke, Williams, Lowe (2006) Arch Intern
 * Med 166(10): 1092-1097.
 *
 * HC3: citation discipline + LOINC source live in `prom-definitions.ts`.
 * HC5: zero em / en dashes anywhere.
 */
import { PromCard, type PromCardProps } from './PromCard';
import { GAD7_DEFINITION } from './prom-definitions';

export type GAD7CardProps = Omit<PromCardProps, 'definition'>;

export function GAD7Card(props: GAD7CardProps) {
  return <PromCard definition={GAD7_DEFINITION} {...props} />;
}
